(() => {
  const name = 'tooltipToggle';

  App.components = App.components || {};

  App.components[name] = (() => {
    const componentSelector = '[data-component="tooltipToggle"]';
    const tooltipBtnSelector = '[data-tooltip-btn]';
    const tooltipContainerSelector = '[data-tooltip-container]';

    const toggleTooltip = ($target) => {
      $target
        .toggleClass('expanded')
        .next(tooltipContainerSelector)
        .toggleClass('show');
    };

    const clickOutsideTooltip = (e, $container) => {
      if ($(e.target).closest(tooltipContainerSelector).length === 0) {
        document.removeEventListener('click', clickOutsideTooltip);
        toggleTooltip($(`.expanded${tooltipBtnSelector}`, $container));
      }
    };

    const clickTooltipButton = (e, $container) => {
      const $btn = $(e.target);
      if ($btn.hasClass('expanded')) {
        clickOutsideTooltip(e, $container);
        return;
      }

      clickOutsideTooltip(e, $container);
      toggleTooltip($btn);
      setTimeout(() => {
        document.addEventListener('click', clickOutsideTooltip);
      }, 200);
    };

    const init = ($container) => {
      if ($container.is(componentSelector)) {
        $container.on('click', tooltipBtnSelector, (e) => clickTooltipButton(e, $container));
      } else {
        $container.on('click', `${componentSelector} ${tooltipBtnSelector}`, (e) => clickTooltipButton(e, $container));
      }
    };

    return {
      init,
    };
  })();
})();
